<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="row mb-2">
          <div class="col-sm-5">
          </div>
          <div class="col-sm-7">
            <div class="float-sm-end d-flex">
            <button type="button" class="btn btn-sm btn-primary mb-2" @click="newAccommodation()">
              <i class="mdi mdi-plus mr-1"></i> Nova Acomodação
            </button>
            </div>
          </div>
          <!-- end col-->
        </div>
      </div>
      <div class="container-fluid custom-scroll">
        <div class="row row-item" v-if="accommodations.length === 0">
          <div class="col texts-box text-truncate">
            <div class="text-2 text-truncate text-center">Nenhuma acomodação cadastrada</div>
          </div>
        </div>
        <div class="row row-item" v-for="(accommodation, i) in accommodations" :key="i">
          <div class="col texts-box text-truncate link" @click="editAccommodation(accommodation.id)">
            <div class="text-1 text-truncate d-flex gap-1">
              {{ accommodation.desc_room }}
              <div class="d-flex align-items-center">
                <svg v-for="(c, i) in accommodation.capacity" :key="i" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" class="icon icon-tabler icons-tabler-filled icon-tabler-bed">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M3 6a1 1 0 0 1 .993 .883l.007 .117v6h6v-5a1 1 0 0 1 .883 -.993l.117 -.007h8a3 3 0 0 1 2.995 2.824l.005 .176v8a1 1 0 0 1 -1.993 .117l-.007 -.117v-3h-16v3a1 1 0 0 1 -1.993 .117l-.007 -.117v-11a1 1 0 0 1 1 -1z"/>
                  <path d="M7 8a2 2 0 1 1 -1.995 2.15l-.005 -.15l.005 -.15a2 2 0 0 1 1.995 -1.85z" />
                </svg>
              </div>
            </div>
            <div class="text-2 text-truncate">Quantidade: {{ accommodation.qty }}</div>
          </div>
          <div class="col-auto">
            <div class="flex justify-end">
              <span class="badge badge-soft-warning font-size-12 p-2" style="min-width:100px">{{ accommodation.category.data.name }}</span>
            </div>
          </div>
          <div class="col-auto">
            <div class="flex justify-end">
              <button type="button" @click="deleteAcco(accommodation.id)" class="link btn btn-outline-danger btn-sm"><i class="bx bx-trash"></i></button>
            </div>
          </div>
        </div>
      </div>
      <modal-form v-model="modalForm" :idHotel=idHotel ref="formAccommodation" @created="updateList"></modal-form>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import ModalForm from './Form'
import Swal from 'sweetalert2'
import { errorMessage, successMessage } from '@/components/alertsMessages'

export default {
  components: {
    ModalForm
  },
  name: 'hotel-accommodation',
  props: {
    idHotel: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      loading: true,
      search: '',
      filter: {
        status: 0
      },
      statusList: ['Todos os status', 'Ativo', 'Inativo'],
      statusLabel: ['', 'Inativo', 'Ativo'],
      modalForm: false,
      modalRoom: false,
      params: {},
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      hotelId: null,
      idParticipant: null,
      submitted: false
    }
  },
  mounted () {
    this.updateList()
    this.loading = false
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('hotelAccommodation', ['accommodations'])
  },
  methods: {
    ...mapActions('hotelAccommodation', {
      getAll: 'getAll',
      destroyAccommodation: 'deleteAccommodation'
    }),
    showFilters () {
      this.$refs.modalFilter.open()
    },
    newAccommodation () {
      this.$refs.formAccommodation.open('')
      this.modalForm = true
    },
    editAccommodation (id) {
      this.$refs.formAccommodation.open(id)
      this.modalForm = true
      this.idCategory = id
    },
    openRooms (id) {
      this.$refs.formAccommodation.open(id)
      this.modalRoom = true
      this.hotelId = id
    },
    deleteAcco (id) {
      Swal.fire({
        title: 'Você tem certeza ?',
        text: 'Essa ação não poderá ser revertida',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(result => {
        if (result.value) {
          try {
            this.destroyAccommodation(id).then((res) => {
              successMessage('Sucesso: Acomodações excluídas com sucesso.', 2500)
              this.updateList()
            }).catch((err) => {
              errorMessage('Alerta: ' + err.message)
            })
          } catch (err) {
            errorMessage('Alerta: ' + err.response.data.message)
          }
        }
      })
    },
    getReport (filter) {
      let params = {
        include: 'category',
        hotel_id: this.idHotel || null
      }
      this.params = params
      // let loeader = this.$loading.show()
      this.getAll(this.params).then((res) => {
        // this.participants = res.data
        // loeader.hide()
      }).catch(error => {
        console.log(error)
        // loeader.hide()
      })
    },
    doSearch () {
      this.params = { ...this.params, search: this.search }
      this.getReport(this.params)
    },
    updateList () {
      this.getReport(this.params)
      // this.$refs.child.getSubscribers()
    }
  },
  watch: {
    // currentPage () { this.updateList() }
    // total () { this.updateList() },
  }
}
</script>
<style lang="scss" scoped>
@import "~bootstrap/scss/functions";
@import "src/design/variables";
.link { cursor: pointer; }
.inativado { background: #f7ebeb }
.swal2-popup {
  font-size: 11px !important;
}
.table-responsive { max-height: 300px;}
.float-sm-end { float: right }

.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
.test-scroll {
  max-height: 300px;
  overflow-y: auto;
}
.custom-scroll{
  overflow-y: auto;
  max-height: 300px;
  padding-bottom: 0;
}
.fix-w {
  --width: 100px;
  --font-size: 13px;
  --icon-size: 16px;
  --btn-justify: space-evenly;
  --btn-padding: 0.20rem 0.08rem;
  @media (min-width: map-get($grid-breakpoints, "md")) {
    --width: 100px;
    --font-size: 13px;
    --icon-size: 16px;
    --btn-justify: space-around;
    --btn-padding: 0.20rem 0.35rem;
  }

  width: var(--width);

  button {
    font-size: var(--font-size);
    display: flex;
    align-items: center;
    justify-content: var(--btn-justify);
    padding: var(--btn-padding);

    i {
      font-size: var(--icon-size);
    }
  }
}

.row-item {
  --padding: 10px 5px;
  @media (min-width: map-get($grid-breakpoints, "md")) {
    --padding: 9px 5px;
  }
  background-color: #ffffff;
  border-radius: 5px;
  margin-bottom: 16px;
  padding: var(--padding);
  border: 1px solid rgba(217, 217, 217, 0.461);
  align-items: center;
  cursor: pointer;
}
.texts-box {
  .text-1 {
    font-size: 14px;
    color: #05162B;
  }

  .text-2 {
    font-size: 12px;
    color: #05162B87;
  }
}
</style>
